export const DEFAULT_DATA = [
  {
    Name: "John Doe",
    Company: "TechCorp",
    Title: "Software Engineer",
    "Phone number": "(555) 123-4567",
    Email: "john.doe@techcorp.com",
    "Registration date": "2023-01-15",
  },
  {
    Name: "Jane Smith",
    Company: "Innovate Ltd",
    Title: "Project Manager",
    "Phone number": "(555) 234-5678",
    Email: "jane.smith@innovatelt.com",
    "Registration date": "2023-02-20",
  },
  {
    Name: "Alice Johnson",
    Company: "Web Solutions",
    Title: "UX Designer",
    "Phone number": "(555) 345-6789",
    Email: "alice.johnson@websolutions.com",
    "Registration date": "2023-03-10",
  },
  {
    Name: "Bob Brown",
    Company: "BuildIt",
    Title: "Construction Manager",
    "Phone number": "(555) 456-7890",
    Email: "bob.brown@buildit.com",
    "Registration date": "2023-04-05",
  },
  {
    Name: "Charlie Davis",
    Company: "FinTech Inc",
    Title: "Financial Analyst",
    "Phone number": "(555) 567-8901",
    Email: "charlie.davis@fintechinc.com",
    "Registration date": "2023-05-12",
  },
  {
    Name: "Dana Lee",
    Company: "HealthFirst",
    Title: "Nurse Practitioner",
    "Phone number": "(555) 678-9012",
    Email: "dana.lee@healthfirst.com",
    "Registration date": "2023-06-01",
  },
  {
    Name: "Evan Martinez",
    Company: "AutoPro",
    Title: "Mechanical Engineer",
    "Phone number": "(555) 789-0123",
    Email: "evan.martinez@autopro.com",
    "Registration date": "2023-07-19",
  },
  {
    Name: "Fiona Green",
    Company: "EduFuture",
    Title: "Curriculum Developer",
    "Phone number": "(555) 890-1234",
    Email: "fiona.green@edufuture.com",
    "Registration date": "2023-08-23",
  },
  {
    Name: "George Harris",
    Company: "MarketMasters",
    Title: "Marketing Director",
    "Phone number": "(555) 901-2345",
    Email: "george.harris@marketmasters.com",
    "Registration date": "2023-09-07",
  },
  {
    Name: "Hannah Wright",
    Company: "LegalEagle",
    Title: "Attorney",
    "Phone number": "(555) 012-3456",
    Email: "hannah.wright@legaleagle.com",
    "Registration date": "2023-10-15",
  },
  {
    Name: "Ian Walker",
    Company: "HomeGoods",
    Title: "Retail Manager",
    "Phone number": "(555) 123-4567",
    Email: "ian.walker@homegoods.com",
    "Registration date": "2023-11-22",
  },
  {
    Name: "Julia King",
    Company: "TravelWise",
    Title: "Travel Agent",
    "Phone number": "(555) 234-5678",
    Email: "julia.king@travelwise.com",
    "Registration date": "2023-12-30",
  },
  {
    Name: "Kevin Scott",
    Company: "CleanEnergy",
    Title: "Environmental Scientist",
    "Phone number": "(555) 345-6789",
    Email: "kevin.scott@cleanenergy.com",
    "Registration date": "2024-01-08",
  },
  {
    Name: "Laura Baker",
    Company: "MediaMinds",
    Title: "Content Strategist",
    "Phone number": "(555) 456-7890",
    Email: "laura.baker@mediaminds.com",
    "Registration date": "2024-02-18",
  },
  {
    Name: "Michael Young",
    Company: "CyberSecure",
    Title: "Cybersecurity Specialist",
    "Phone number": "(555) 567-8901",
    Email: "michael.young@cybersecure.com",
    "Registration date": "2024-03-29",
  },
  {
    Name: "Nina Patel",
    Company: "AgriTech",
    Title: "Agricultural Engineer",
    "Phone number": "(555) 678-9012",
    Email: "nina.patel@agritech.com",
    "Registration date": "2024-04-10",
  },
];
